export default function kebabCase(str){return str.replace(/([a-zA-Z])(?=[A-Z])/g,"$1-").toLowerCase()}